import React from 'react';
import { CTAButton } from './CTAButton';
import { useInView } from '../hooks/useInView';
export function CTASection() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section className="py-24 px-4 bg-[#0F0F0F] relative overflow-hidden" data-id="element-47">
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[400px] bg-gold-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-48" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-49">
        <div ref={ref} className={`text-center ${isVisible ? 'anim-fade-up' : 'anim-hidden'}`} data-id="element-50">
          <div className="mb-16" data-id="element-51">
            <CTAButton data-id="element-52" />
          </div>

          <div className="text-left space-y-8 bg-[#141414] border border-gray-800 rounded-3xl p-8 md:p-12" data-id="element-53">
            <p className="text-2xl font-serif text-white text-center mb-8" data-id="element-54">
              Hay dos versiones de vos dentro de 90 días.
            </p>
            <div className="space-y-6" data-id="element-55">
              <div className="flex gap-4" data-id="element-56">
                <div className="w-1.5 bg-gray-700 rounded-full shrink-0" data-id="element-57" />
                <p className="text-lg text-gray-400" data-id="element-58">
                  <strong className="text-white" data-id="element-59">La primera</strong> sigue
                  igual: cobrando, pagando, llegando justo, sin saber a dónde
                  fue el dinero. Otra vez.
                </p>
              </div>
              <div className="flex gap-4" data-id="element-60">
                <div className="w-1.5 bg-gold-500 rounded-full shrink-0" data-id="element-61" />
                <p className="text-lg text-gray-300" data-id="element-62">
                  <strong className="text-gold-400" data-id="element-63">La segunda</strong> terminó
                  el mes con plata en la cuenta por primera vez en mucho tiempo.
                  Tiene un fondo de emergencia que le da tranquilidad. Está
                  haciendo su primera inversión. Y sobre todo —{' '}
                  <strong className="text-white" data-id="element-64">
                    siente que tiene el control.
                  </strong>
                </p>
              </div>
            </div>
            <div className="pt-8 border-t border-gray-800 text-center space-y-4" data-id="element-65">
              <p className="text-xl text-white font-medium" data-id="element-66">
                La diferencia entre esas dos versiones sos vos. Y esta decisión.
              </p>
              <p className="text-2xl font-serif text-gold-400 font-bold" data-id="element-67">
                El método está acá. El sistema funciona. Solo falta que lo uses.
              </p>
            </div>
          </div>

          <div className="mt-16" data-id="element-68">
            <CTAButton data-id="element-69" />
          </div>
        </div>
      </div>
    </section>;
}